import React from 'react';

import { WellWrapper } from './Styled';

const Well = props => {
  return <WellWrapper {...props} />;
};

export default Well;
